import { render, staticRenderFns } from "./newsCoreRead.vue?vue&type=template&id=6aacdb33&"
import script from "./newsCoreRead.vue?vue&type=script&lang=js&"
export * from "./newsCoreRead.vue?vue&type=script&lang=js&"
import style0 from "./newsCoreRead.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports